namespace RioERP.Reports {
    export interface OrderSaleReportForm {
        OrderId: Serenity.IntegerEditor;
        OrderDate: Serenity.DateEditor;
        CustomerName: Serenity.StringEditor;
        CustomerMobile1: Serenity.StringEditor;
        CustomerEmail1: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ProductSpecificationName: Serenity.StringEditor;
        City: Serenity.StringEditor;
        Address1: Serenity.StringEditor;
        StateName: Serenity.StringEditor;
        PinCode: Serenity.StringEditor;
        Items: Serenity.StringEditor;
        TransactionId: Serenity.StringEditor;
        PaymentStatus: Serenity.EnumEditor;
        DiscountCode: Serenity.StringEditor;
        PaymentMode: Serenity.EnumEditor;
        InvoiceNumber: Serenity.StringEditor;
        Gstin: Serenity.StringEditor;
        Currencies: Serenity.IntegerEditor;
        SourceType: Serenity.EnumEditor;
        AffiliateId: Serenity.StringEditor;
        TaxableAmount: Serenity.DecimalEditor;
        Total: Serenity.DecimalEditor;
        DiscountAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmountNet: Serenity.DecimalEditor;
        CgstRate: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstRate: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstRate: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        TotalTax: Serenity.DecimalEditor;
    }

    export class OrderSaleReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderSaleReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderSaleReportForm.init)  {
                OrderSaleReportForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(OrderSaleReportForm, [
                    'OrderId', w0,
                    'OrderDate', w1,
                    'CustomerName', w2,
                    'CustomerMobile1', w2,
                    'CustomerEmail1', w2,
                    'ProductName', w2,
                    'ProductSpecificationName', w2,
                    'City', w2,
                    'Address1', w2,
                    'StateName', w2,
                    'PinCode', w2,
                    'Items', w2,
                    'TransactionId', w2,
                    'PaymentStatus', w3,
                    'DiscountCode', w2,
                    'PaymentMode', w3,
                    'InvoiceNumber', w2,
                    'Gstin', w2,
                    'Currencies', w0,
                    'SourceType', w3,
                    'AffiliateId', w2,
                    'TaxableAmount', w4,
                    'Total', w4,
                    'DiscountAmount', w4,
                    'NetAmount', w4,
                    'TaxableAmountNet', w4,
                    'CgstRate', w4,
                    'CgstAmount', w4,
                    'SgstRate', w4,
                    'SgstAmount', w4,
                    'IgstRate', w4,
                    'IgstAmount', w4,
                    'TotalTax', w4
                ]);
            }
        }
    }
}
